import { render } from "./Team_manager.vue?vue&type=template&id=bb6b2536&scoped=true"
import script from "./Team_manager.vue?vue&type=script&lang=js"
export * from "./Team_manager.vue?vue&type=script&lang=js"

import "./Team_manager.vue?vue&type=style&index=0&id=bb6b2536&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bb6b2536"

export default script